import App from '../../App';
import isEmpty from 'lodash/isEmpty';
export const BMP_SENSOR_DATA_HEADER_KEY = 'X-acf-sensor-data';
class Akamai {
    constructor() {
        this.onFulfilled = (config) => {
            if (!isEmpty(App.envVars?.akamaiBMPSensorData)) {
                const restrictedResourcePaths = App.envVars?.akamaiRestrictedResourcePaths ?? [];
                for (let i = 0; i < restrictedResourcePaths.length; i++) {
                    const path = restrictedResourcePaths[i];
                    if (config.url && config.url.includes(path)) {
                        console.log(`intercepting axios request url: ${config.url} to add BMP restrictions`);
                        config.headers[BMP_SENSOR_DATA_HEADER_KEY] = App.envVars?.akamaiBMPSensorData;
                        break;
                    }
                }
            }
            return config;
        };
        this.onRejected = (error) => {
            return Promise.reject(error);
        };
        // To prevent creation of instance from outside the class
    }
    static get instance() {
        if (!Akamai._instance) {
            Akamai._instance = new Akamai();
        }
        return Akamai._instance;
    }
}
export default Akamai;
